import { QueryKey } from '@/configs/queryKeys';
import { Attachment } from '@/types/types';
import EntityApi, { BaseEntity } from './EntityApi';

export enum FileCategory {
	ATTACHMENT = 'ATTACHMENT',
	MARKETING = 'MARKETING',
}

export interface File extends BaseEntity {
	name: string;
	description: string;
	attachment: Attachment;
	category: FileCategory;
	updatedAt: string;
	createdAt: string;
}

class FileApi extends EntityApi<File> {
	constructor() {
		super(QueryKey.files);
	}
}

export default new FileApi();
